module.exports = __webpack_public_path__ + "img/income1.efe49479.png";